import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
// Pages
import LoginPage from './components/pages/LoginPage';
import WelcomePage from './components/pages/WelcomePage';
import Callback from './components/pages/CallBack';
import AccueilPage from './components/pages/AccueilPage';
import BotNotPresentPage from './components/pages/BotNotPresentPage';
import MemberLayout from './components/layout/MemberLayout';
import MemberPage from './components/pages/MemberPage';
import PreferencesPage from './components/pages/PreferencesPage';
import AllianceInfoPage from './components/pages/AllianceInfoPage';
import ReservationSheetPage from './components/pages/ReservationSheetPage';
import AdminPage from './components/pages/AdminPage';
// Config pages
//
import ConfigBaremePage from './components/config/ConfigBaremePage';
import ConfigTempoPage from './components/config/ConfigTempoPage';
// Événements : page masquée pour le moment (code conservé)
// import ConfigEventPage from './components/config/ConfigEventPage';
import ChannelConfigPage from './components/config/ChannelConfigPage';
import ReservationPage from './components/config/ReservationPage';
import ReservationListPage from './components/config/ReservationListPage';
import ZonesPage from './components/config/ZonesPage';
import EncheresPage from './components/auction/EncheresPage';
import AuctionDetailPage from './components/auction/AuctionDetailPage';
import AuctionMemberPage from './components/auction/AuctionMemberPage';
import AdminPlayerStatsPage from './components/config/AdminPlayerStatsPage';
import PepitesPage from './components/config/PepitesPage';
import RecoveryPage from './components/config/RecoveryPage';
import PlPage from './components/config/PlPage';
import PersonnagesAdminPage from './components/personnages/PersonnagesAdminPage';
import PersonnagesMemberPage from './components/personnages/PersonnagesMemberPage';
// Saison pages
import SaisonPage from './components/saison/SaisonPage';
import EditSaisonPage from './components/saison/EditSaisonPage';
import MergeSaisonsPage from './components/saison/MergeSaisonsPage';
// Layout
import NotificationContainer from './components/layout/NotificationContainer';
import ProtectedRoute from './components/layout/ProtectedRoute';
import SuperAdminRoute from './components/layout/SuperAdminRoute';
import RequirePermission from './components/layout/RequirePermission';
import SuperAdminButton from './components/layout/SuperAdminButton';
import MaintenanceGate from './components/layout/MaintenanceGate';
// Contexts
import { AuthProvider } from './contexts/AuthContexte';
import { LanguageProvider } from './contexts/LanguageContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { AccessProvider } from './contexts/AccessContext';

// Ancienne adresse de création : la création se fait maintenant dans une fenêtre de la page Saisons
const CreateSaisonRedirect = () => {
    const { serverId } = useParams();
    return <Navigate to={`/server/${serverId}/saison?create=1`} replace />;
};

function App() {
    return (
        <LanguageProvider>
            <AuthProvider>
                <AccessProvider>
                    <NotificationProvider>
                    <Router>
                    <MaintenanceGate>
                        <Routes>
                            {/* Routes publiques */}
                            <Route path="/" element={<LoginPage />} />
                            <Route path="/callback" element={<Callback />} />
                            <Route path="/auth/discord/callback" element={<Callback />} />

                            {/* Routes protégées */}
                            <Route path="/welcome" element={
                                <ProtectedRoute>
                                    <WelcomePage />
                                </ProtectedRoute>
                            } />

                            {/* Route principale avec sous-routes */}
                            <Route path="/server/:serverId/*" element={
                                <ProtectedRoute>
                                    <AccueilPage />
                                </ProtectedRoute>
                            }>
                                <Route path="configuration" element={<RequirePermission permission="configuration"><ChannelConfigPage /></RequirePermission>} />
                                <Route path="bareme" element={<RequirePermission permission="bareme"><ConfigBaremePage /></RequirePermission>} />
                                <Route path="tempo" element={<RequirePermission permission="tempo"><ConfigTempoPage /></RequirePermission>} />
                                <Route path="saison" element={<RequirePermission permission="saisons"><SaisonPage /></RequirePermission>} />
                                <Route path="saisons/:saisonId/edit" element={<RequirePermission permission="saisons"><EditSaisonPage /></RequirePermission>} />
                                <Route path="saisons/merge" element={<RequirePermission permission="fusion"><MergeSaisonsPage /></RequirePermission>} />
                                {/* <Route path="evenement" element={<RequirePermission permission="evenements"><ConfigEventPage /></RequirePermission>} /> */}
                                <Route path="zones" element={<RequirePermission permission="zones"><ZonesPage /></RequirePermission>} />
                                <Route path="reservation" element={<RequirePermission permission="reservation"><ReservationListPage /></RequirePermission>} />
                                <Route path="reservation/:sessionId/edit" element={<RequirePermission permission="reservation"><ReservationPage /></RequirePermission>} />
                                <Route path="encheres" element={<RequirePermission permission="encheres"><EncheresPage /></RequirePermission>} />
                                <Route path="encheres/:auctionId" element={<RequirePermission permission="encheres"><AuctionDetailPage /></RequirePermission>} />
                                <Route path="admin-stats" element={<RequirePermission permission="statistiques"><AdminPlayerStatsPage /></RequirePermission>} />
                                <Route path="pepites" element={<RequirePermission permission="pepites"><PepitesPage /></RequirePermission>} />
                                <Route path="rattrapage" element={<RequirePermission permission="rattrapage"><RecoveryPage /></RequirePermission>} />
                                <Route path="pl" element={<RequirePermission permission="pl"><PlPage /></RequirePermission>} />
                                <Route path="personnages" element={<RequirePermission permission="personnages"><PersonnagesAdminPage /></RequirePermission>} />
                            </Route>

                            {/* Routes indépendantes protégées */}
                            <Route path="/server/:serverId/create-saison" element={
                                <ProtectedRoute>
                                    <CreateSaisonRedirect />
                                </ProtectedRoute>
                            } />

                            {/* Routes membre */}
                            <Route path="/server/:serverId/member/*" element={
                                <ProtectedRoute>
                                    <MemberLayout />
                                </ProtectedRoute>
                            }>
                                <Route index element={<AllianceInfoPage />} />
                                <Route path="perso" element={<MemberPage />} />
                                <Route path="personnages" element={<PersonnagesMemberPage />} />
                                <Route path="preferences" element={<PreferencesPage />} />
                                <Route path="fiche" element={<ReservationSheetPage />} />
                                <Route path="encheres" element={<AuctionMemberPage />} />
                                {/* Ancienne page « Mes réservations » : intégrée à la fiche */}
                                <Route path="reservation" element={<Navigate to="../fiche" replace />} />
                            </Route>

                            {/* Route pour la page BotNotPresent */}
                            <Route path="/server/:serverId/bot-not-present" element={
                                <ProtectedRoute>
                                    <BotNotPresentPage />
                                </ProtectedRoute>
                            } />

                            {/* Bouton Admin : propriétaire et Administrateurs Site */}
                            <Route path="/admin" element={
                                <SuperAdminRoute>
                                    <AdminPage />
                                </SuperAdminRoute>
                            } />
                        </Routes>
                        <SuperAdminButton />
                    </MaintenanceGate>
                    </Router>
                    <NotificationContainer />
                </NotificationProvider>
                </AccessProvider>
            </AuthProvider>
        </LanguageProvider>
    );
}

export default App;